var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "FormFieldsContainer",
        [
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkSatelite.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledTemperatura },
                model: {
                  value: _vm.formFields.checkSatelite.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkSatelite, "value", $$v)
                  },
                  expression: "formFields.checkSatelite.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkHDOP.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledTemperatura },
                model: {
                  value: _vm.formFields.checkHDOP.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkHDOP, "value", $$v)
                  },
                  expression: "formFields.checkHDOP.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            [
              _c("v-checkbox", {
                attrs: {
                  label: this.formFields.checkLongYLat.label,
                  value: true,
                  disabled: _vm.accion === 3
                },
                on: { change: _vm.handledTemperatura },
                model: {
                  value: _vm.formFields.checkLongYLat.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.checkLongYLat, "value", $$v)
                  },
                  expression: "formFields.checkLongYLat.value"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }